<template>
  <div class="booking-add">
    <div class="booking-header">
      <div @click="$router.go(-1)">
        取消
      </div>
      <div
        class="booking-submit"
        @click="submit"
      >
        完成
      </div>
    </div>
    <div class="booking-division" />
    <div class="booking-form">
      <van-form ref="addForm">
        <van-field
          input-align="right"
          v-model="addForm.customer_name"
          name="客户姓名"
          label="客户姓名"
          :readonly="type === 'edit'"
          required
          :rules="[{ required: true, message: '请填写客户姓名' }]"
          placeholder=""
        >
        </van-field>
        <van-field
          input-align="right"
          readonly
          clickable
          name="picker"
          :value="addForm.customer_id_card_type"
          label="证件类型"
          placeholder=""
          required
          :rules="[{ required: true, message: '请选择证件类型' }]"
          @click="openPicker('showCardTypePicker')"
          class="booking-form-hide-input"
        >
          <template #button>
            <div class="booking-form-select">
              {{ addForm.customer_id_card_type ? hisEnum.lst_document_typeMap[addForm.customer_id_card_type] : '点击选择证件类型' }}<i
                v-show="type === 'add'"
                class="el-icon-arrow-right"
              ></i>
            </div>
          </template>
        </van-field>
        <van-popup
          v-model="showCardTypePicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="hisEnum.lst_document_type"
            value-key="Text"
            @confirm="onCardTypeConfirm"
            @cancel="showCardTypePicker = false"
          />
        </van-popup>
        <van-field
          input-align="right"
          v-model="addForm.customer_id_card_no"
          name="证件号码"
          label="证件号码"
          :readonly="type === 'edit'"
          required
          :rules="[
            { required: true, message: '请填写证件号码' },
            { validator: validatorCardNo, message: '请输入正确证件号码' }
        ]"
          placeholder=""
          @blur="cuotomerIdNumber"
        >
        </van-field>
        <van-field
          name="customer_sex"
          input-align="right"
          label="客户性别"
          placeholder=""
          required
          :rules="[{ required: true, message: '请选择客户性别' }]"
        >
          <template #input>
            <van-radio-group
              v-model="addForm.customer_sex"
              direction="horizontal"
              :disabled="type === 'edit'"
            >
              <van-radio
                v-for="option in hisEnum.lst_sex"
                checked-color="#DA0032"
                :key="option.Value"
                :name="option.Value"
              >{{ option.Text }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          input-align="right"
          readonly
          clickable
          name="calendar"
          :value="addForm.customer_birthday"
          label="出生日期"
          placeholder="点击选择出生日期"
          required
          :rules="[{ required: true, message: '请选择客户出生日期' }]"
          @click="openPicker('showCalendar')"
        >
          <template #button>
            <div class="booking-form-select">
              <i
                v-show="type === 'add'"
                class="el-icon-arrow-right"
              ></i>
            </div>
          </template>
        </van-field>
        <van-calendar
          :min-date="new Date('1920-01-01')"
          :max-date="new Date()"
          :default-date="new Date('1980-01-01')"
          :lazy-render="true"
          v-model="showCalendar"
          @confirm="onCalendarConfirm"
        />
        <van-field
          v-if="type === 'edit'"
          input-align="right"
          v-model="addForm.customer_mobile"
          name="手机号码"
          label="手机号码"
          :readonly="type === 'edit'"
          required
          :rules="[
            { required: true, message: '请填写手机号码' },
        ]"
          placeholder=""
        >
        </van-field>
        <van-field
          v-else
          input-align="right"
          v-model="addForm.customer_mobile"
          name="手机号码"
          label="手机号码"
          :readonly="type === 'edit'"
          required
          :rules="[
            { required: true, message: '请填写手机号码' },
            { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '请填写正确手机号码' },
        ]"
          placeholder=""
        >
        </van-field>
        <template v-if="type === 'edit'">
          <van-field
            input-align="right"
            v-model="addForm.customer_level"
            name="客户级别"
            label="客户级别"
            readonly
            placeholder=""
          >
          </van-field>
          <van-field
            input-align="right"
            v-model="addForm.stored_amount"
            name="储值金余额"
            label="储值金余额"
            readonly
            placeholder=""
          >
          </van-field>
          <van-field
            input-align="right"
            v-model="addForm.history_amount"
            name="历史消费金额"
            label="历史消费金额"
            readonly
            placeholder=""
          >
          </van-field>
        </template>
        <van-field
          input-align="right"
          readonly
          clickable
          name="picker"
          required
          :value="addForm.customer_region_name"
          label="所属地区"
          placeholder="点击选择所属地区"
          :rules="[{ required: true, message: '请选择所属地区' }]"
          @click="showAddressPicker = true"
        >
          <template #button>
            <div class="booking-form-select">
              <i class="el-icon-arrow-right"></i>
            </div>
          </template>
        </van-field>

        <van-popup
          v-model="showAddressPicker"
          position="bottom"
        >
          <div class="booking-home-search">
            <div class="booking-home-search-header">
              <div @click="showAddressPicker = false">
                取消
              </div>
              <div
                class="booking-submit"
                @click="onAddressConfirm"
              >
                完成
              </div>
            </div>
            <div class="booking-division" />

            <form action="/">
              <van-search
                v-model="searchForm.address"
                placeholder="请输入搜索关键词"
                show-action
                @search="onAddressSearch"
              >
                <template #action>
                  <div @click="onAddressSearch(searchForm.address)">搜索</div>
                </template>
              </van-search>
            </form>
            <div class="booking-division" />

            <div class="booking-home-search-list">
              <div
                v-for="item in addressList"
                :key="item.Value"
                class="booking-home-search-item"
                :class="{
                    'booking-home-search-item-current': item.select
                }"
                @click="onAddressChange(item)"
              >
                {{ item.Text }}
              </div>
            </div>
          </div>
        </van-popup>
        <van-field
          input-align="right"
          readonly
          clickable
          name="picker"
          rows="1"
          autosize
          type="textarea"
          :value="addForm.scrm_account_name"
          required
          label="所属渠道"
          placeholder="点击选择所属渠道"
          :rules="[{ required: true, message: '点击选择所属渠道' }]"
          @click="showChannelPicker = true"
        >
          <template #button>
            <div class="booking-form-select">
              <i class="el-icon-arrow-right"></i>
            </div>
          </template>
        </van-field>
        <!-- <div class="booking-add-relation-tips">
          必填，如果无渠道，请选择“散客”
        </div> -->
        <van-popup
          v-model="showChannelPicker"
          position="bottom"
        >
          <div class="booking-home-search">
            <div class="booking-home-search-header">
              <div @click="showChannelPicker = false">
                取消
              </div>
              <div
                class="booking-submit"
                @click="onChannelConfirm"
              >
                完成
              </div>
            </div>
            <div class="booking-division" />

            <form action="/">
              <van-search
                v-model="searchForm.channel"
                placeholder="请输入搜索关键词"
                show-action
                @search="onChannelSearch"
              >
                <template #action>
                  <div @click="onChannelSearch(searchForm.channel)">搜索</div>
                </template>
              </van-search>
            </form>
            <div class="booking-division" />

            <div class="booking-home-search-list">
              <div
                v-for="item in channelColumns"
                :key="item.account_id"
                class="booking-home-search-item"
                :class="{
                    'booking-home-search-item-current': item.select
                }"
                @click="channelChange(item)"
              >
                {{ item.showName }}
              </div>
            </div>
          </div>
        </van-popup>
        <!-- <van-popup
          v-model="showChannelPicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="channelColumns"
            @confirm="onChannelConfirm"
            @cancel="showChannelPicker = false"
          />
        </van-popup> -->

        <van-field
          input-align="right"
          readonly
          clickable
          name="picker"
          value=""
          label="客户标签"
          placeholder=""
          @click="openLablePicker"
          class="booking-form-hide-input"
        >
          <template #button>
            <div class="booking-form-select">
              {{ addForm.label_list && addForm.label_list.length > 0 ? addForm.label_list.map(item => item.label_name).join('、') : '点击选择客户标签' }}<i class="el-icon-arrow-right"></i>
            </div>
          </template>
        </van-field>
        <van-popup
          v-model="showLabelPicker"
          position="bottom"
        >
          <div class="booking-home-search">
            <div class="booking-home-search-header">
              <div @click="showLabelPicker = false">
                取消
              </div>
              <div
                class="booking-submit"
                @click="onLabelConfirm"
              >
                完成
              </div>
            </div>
            <div class="booking-division" />

            <div class="booking-label-search-list">
              <div
                v-for="item in labelList"
                :key="item.label_code"
                class="booking-label-search-item booking-label"
                :class="{
                    'booking-label-search-item-current': item.select
                }"
                @click="onLabelChange(item)"
              >
                {{ item.label_name }}
              </div>
            </div>
          </div>
        </van-popup>
        <van-field
          input-align="right"
          readonly
          clickable
          name="picker"
          :value="addForm.book_family_member_patient_id"
          label="家庭成员"
          placeholder=""
          :rules="[{ required: addForm.book_family_relation_name, message: '请选择家庭成员' }]"
          @click="showMemberPicker = true"
          class="booking-form-hide-input"
        >
          <template #button>
            <div class="booking-form-select">
              {{ addForm.book_family_member_patient_id ? addForm.book_family_member_name : '点击选择家庭成员' }}<i class="el-icon-arrow-right"></i>
            </div>
          </template>
        </van-field>
        <van-popup
          v-model="showMemberPicker"
          position="bottom"
        >
          <div class="booking-home-search">
            <div class="booking-home-search-header">
              <div @click="showMemberPicker = false">
                取消
              </div>
              <div
                class="booking-submit"
                @click="onMemberConfirm"
              >
                完成
              </div>
            </div>
            <div class="booking-division" />

            <form action="/">
              <van-search
                v-model="searchForm.customer_name"
                placeholder="请输入搜索关键词"
                show-action
                @search="onMemberSearch"
              >
                <template #action>
                  <div @click="onMemberSearch">搜索</div>
                </template>
              </van-search>
            </form>
            <div class="booking-division" />

            <div class="booking-home-search-list">
              <div
                v-for="item in memberList"
                :key="item.empi"
                class="booking-home-search-item"
                :class="{
                    'booking-home-search-item-current': item.select
                }"
                @click="onMemberChange(item)"
              >
                {{ item.name }} {{ item.user_mobile_desensitization }}
              </div>
            </div>
          </div>
        </van-popup>
        <van-field
          input-align="right"
          readonly
          clickable
          name="picker"
          :value="addForm.book_family_relation_name"
          label="家庭关系"
          placeholder="点击选择家庭关系"
          :rules="[{ required: addForm.book_family_member_patient_id, message: '请选择家庭关系' }]"
          @click="showRelationlPicker = true"
        >
          <template #button>
            <div class="booking-form-select">
              <i class="el-icon-arrow-right"></i>
            </div>
          </template>
        </van-field>
        <van-popup
          v-model="showRelationlPicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            value-key="name"
            :columns="allEnum.ApplyFamilyRelationArr"
            @confirm="onRelationlConfirm"
            @cancel="showRelationlPicker = false"
          />
        </van-popup>
        <div
          class="booking-add-relation-tips"
          v-show="addForm.book_family_member_patient_id && addForm.book_family_relation"
        >
          {{ addForm.customer_name }}是{{ addForm.book_family_member_name }}的{{ addForm.book_family_relation_name }}
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import bookingService from "@/apis/booking";
import enums from "@/views/booking/mixins/enums";
import moment from "moment";
import cuotomerService from "@/apis/customer/index.js";
// import hisService from "@/apis/his/index";

import { Toast } from "vant";
import idCardTool from "@/utils/idCard.js";
import * as dd from "dingtalk-jsapi";
import getUserInfo from "@/models/userInfo";
import { deepClone } from "@/utils/utils";

const idCardType = "1";
let memberTimer = null;
let originChanellList = [];

export default {
  data() {
    return {
      type: "add",
      addForm: {
        label_list: [],
      },
      showCardTypePicker: false,
      cardTypeColumns: [],

      showSexPicker: false,
      sexColumns: [],

      showChannelPicker: false,
      channelColumns: [],
      selectChannel: {},

      showRelationlPicker: false,
      relationlColumns: [],

      showCalendar: false,

      showMemberPicker: false,
      memberList: [],
      selectMember: {},

      showLabelPicker: false,
      labelList: [],
      selectLabel: [],

      showAddressPicker: false,
      addressList: [],
      selectAddress: {},

      searchForm: {},

      submiting: false,
      currentUserInfo: {},
    };
  },
  mixins: [enums],
  async created() {
    this.type = this.$route.query.type || "add";
    const userInfo = await getUserInfo();
    console.log("userInfo", userInfo);
    this.currentUserInfo = userInfo;
    if (this.type === "edit") {
      this.$nextTick(() => {
        this.getCustomerInfo();
        if (dd.env.platform !== "notInDingTalk") {
          dd.biz.navigation.setTitle({
            title: "编辑客户",
          });
        }
      });
    }
    this.getAllChanell();
    // this.getCustomerList();
    this.customerLabelList();
  },
  methods: {
    initScrmAccountName() {
      const { addForm, channelColumns } = this;
      if (
        addForm.customer_empi &&
        channelColumns &&
        channelColumns.length > 0
      ) {
        channelColumns.forEach((item) => {
          if (item.channel_id == addForm.scrm_account_id) {
            addForm.scrm_account_name = item.channel_name;
          }
        });
      }
      this.addressList = this.hisEnum.lst_customer_region_type;
    },
    async submit() {
      const { addForm, currentUserInfo } = this;
      let pass = true;
      if (this.submiting) {
        Toast("提交中，请勿重复点击");
        return;
      }
      try {
        await this.$refs.addForm.validate();
      } catch (e) {
        pass = false;
      }
      if (!pass) {
        return;
      }
      const mergeParams = {
        SubmitUserId: currentUserInfo.user_id,
        SubmitUser: currentUserInfo.user_name,
        SubmitUserPhone: currentUserInfo.mobile,
      };
      if (this.type === "edit") {
        mergeParams.customer_id_card_no = addForm.customer_id_card_no_origin;
        mergeParams.customer_mobile = addForm.customer_mobile_origin;
      }
      addForm.label_code_list = addForm.label_list.map(
        (item) => item.label_code
      );
      this.submiting = true;
      bookingService
        .customerEdit(Object.assign({}, addForm, mergeParams))
        .then((res) => {
          this.submiting = true;
          this.$store.dispatch("booking/setUserInfo", res.customer_info);
          this.$router.go(-1);
        })
        .catch(() => {
          this.submiting = false;
        });
    },
    openPicker(pickerName) {
      const { type } = this;
      if (type === "edit") return;
      this[pickerName] = true;
    },
    onChannelSearch(query) {
      this.scrmAccounts(query);
    },
    getAllChanell() {
      this.loading = true;

      const params = {
        filter: "",
      };
      cuotomerService.scrmAccounts(params).then((res) => {
        if (res && res.length > 0) {
          res.forEach((item) => {
            item.showName = `${item.account_name}(${item.user_name})`;
          });
          originChanellList = res;
          this.channelColumns = res;
        } else {
          this.channelColumns = [];
        }
        this.initScrmAccountName();

        this.loading = false;
        return true;
      });
    },
    scrmAccounts(query = "") {
      if (!query) {
        this.channelColumns = originChanellList;
      } else {
        this.channelColumns = originChanellList.filter((item) => {
          return item.showName.indexOf(query) !== -1;
        });
      }
    },
    channelChange(option) {
      const { channelColumns } = this;
      channelColumns.forEach((column) => {
        column.select = false;
      });
      option.select = true;
      this.selectChannel = option;
      this.channelColumns = [...this.channelColumns];
    },
    onChannelConfirm() {
      const { addForm, selectChannel } = this;
      if (!selectChannel.account_id) {
        Toast("请选择渠道");
        return;
      }
      addForm.scrm_account_id = selectChannel.account_id;
      addForm.scrm_account_name = selectChannel.account_name;
      addForm.scrm_user_id = selectChannel.user_id;
      addForm.scrm_user_name = selectChannel.user_name;
      addForm.scrm_important_level = selectChannel.important_level;
      this.showChannelPicker = false;
    },
    onAddressChange(option) {
      const addressList = this.addressList;
      addressList.forEach((item) => {
        item.select = false;
      });
      option.select = true;
      this.addressList = [...addressList];
      this.selectAddress = option;
    },

    onAddressConfirm() {
      const { addForm, selectAddress } = this;
      if (!selectAddress.Value) {
        Toast("请选择区域");
        return;
      }
      addForm.customer_region_code = selectAddress.Value;
      addForm.customer_region_name = selectAddress.Text;
      this.showAddressPicker = false;
    },
    onAddressSearch(query) {
      const lst_customer_region_type = this.hisEnum.lst_customer_region_type;
      this.addressList = lst_customer_region_type.filter((item) => {
        return item.Text.indexOf(query) !== -1;
      });
    },
    onMemberSearch() {
      const { searchForm } = this;
      this.getCustomerList(searchForm.customer_name);
    },

    getCustomerList(customer_name = "") {
      const params = {
        in_text: customer_name,
        pageNo: 1,
        pageSize: 9999,
      };

      let currentTimer = new Date().getTime();
      memberTimer = currentTimer;
      bookingService.hisCustomerSearch(params).then((res) => {
        if (currentTimer === memberTimer) {
          res.forEach((item) => {
            if (item.user_mobile) {
              item.user_mobile_desensitization = this.desensitization(
                item.user_mobile,
                3,
                -4
              );
            }
          });
          this.memberList = res;
        }
      });
    },
    onMemberChange(option) {
      const { memberList } = this;
      memberList.forEach((item) => (item.select = false));
      option.select = true;
      this.selectMember = option;
      this.memberList = [...memberList];
    },
    onMemberConfirm() {
      const { addForm, selectMember } = this;
      if (!selectMember || !selectMember.empi) {
        Toast("请选择家庭成员");
        return;
      }

      addForm.book_family_member_patient_id = selectMember.empi;
      addForm.book_family_member_name = selectMember.name;
      this.showMemberPicker = false;
    },
    onCardTypeConfirm(option) {
      const { addForm } = this;
      addForm.customer_id_card_type = option.Value;
      this.showCardTypePicker = false;
    },
    onSexConfirm() {},
    onCalendarConfirm(date) {
      const { addForm } = this;
      addForm.customer_birthday = moment(date).format("YYYY-MM-DD");
      this.showCalendar = false;
    },
    onRelationlConfirm(option) {
      const { addForm } = this;
      addForm.book_family_relation = option.value;
      addForm.book_family_relation_name = option.name;
      this.showRelationlPicker = false;
    },

    cuotomerIdNumber() {
      const { addForm } = this;
      const value = addForm.customer_id_card_no;
      if (
        idCardTool.checkIdCardNo(value) &&
        addForm.customer_id_card_type == "1"
      ) {
        const cardInfo = idCardTool.getIdCardInfo(value);
        addForm.customer_birthday = cardInfo.birthday;
        addForm.customer_sex = cardInfo.gender === "男" ? 1 : 2;
        this.addForm = {
          ...addForm,
        };
        this.$refs.addForm.$forceUpdate();
      }
    },
    validatorCardNo(value) {
      const { addForm, type } = this;
      if (
        type === "add" &&
        addForm.customer_id_card_type == idCardType &&
        !idCardTool.checkIdCardNo(value)
      ) {
        return false;
      } else {
        return true;
      }
    },
    getCustomerInfo() {
      const { allEnum } = this;
      const params = {
        customer_empi: this.$route.query.id,
        customer_name: "",
      };
      bookingService.customerInfo(params).then((res) => {
        res.customer_mobile_origin = res.customer_mobile;
        res.customer_mobile = this.desensitization(res.customer_mobile, 3, -4);
        res.customer_id_card_no_origin = res.customer_id_card_no;
        res.customer_id_card_no = this.desensitization(
          res.customer_id_card_no,
          3,
          -4
        );

        this.addForm = {
          ...res,
          book_family_relation_name: res.book_family_relation
            ? allEnum.ApplyFamilyRelation[res.book_family_relation]
            : undefined,
        };
        this.initScrmAccountName();
      });
    },
    openLablePicker() {
      const { addForm, labelList } = this;
      labelList.forEach((item) => (item.select = false));
      Array.isArray(addForm.label_list) &&
        addForm.label_list.forEach((lable) => {
          labelList.some((item) => {
            if (item.label_code === lable.label_code) {
              item.select = true;
              return true;
            }
          });
        });
      this.selectLabel = deepClone(addForm.label_list);
      this.labelList = [...labelList];
      this.showLabelPicker = true;
    },
    onLabelChange(option) {
      const { labelList, selectLabel } = this;
      if (option.select) {
        option.select = false;
        const currentIndex = selectLabel.findIndex(function (item) {
          return item.label_code === option.label_code;
        });
        console.log(currentIndex);
        selectLabel.splice(currentIndex, 1);
      } else {
        option.select = true;
        selectLabel.push(option);
      }
      this.labelList = [...labelList];
    },
    onLabelConfirm() {
      const { addForm, selectLabel } = this;
      // if (!selectLabel || selectLabel.length === 0) {
      //   Toast("请选择客户标签");
      //   return;
      // }

      addForm.label_list = selectLabel;
      this.showLabelPicker = false;
    },
    customerLabelList() {
      const { currentUserInfo } = this;
      const params = {
        label_name: "",
        user_id: currentUserInfo.ding_user_id,
      };
      bookingService.customerLabelList(params).then((res) => {
        this.labelList = res;
      });
    },
    goPage(name) {
      this.$router.push({
        name,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-add {
  .van-radio--horizontal {
    margin-right: 0;
    margin-left: 12px;
  }
}

.booking-add-relation-tips {
  padding: 15px 20px;
  color: #da0032;
  font-size: 15px;
  background: rgba(0, 48, 87, 0.2);
}
.booking-label-search-list {
  display: flex;
  flex-wrap: wrap;
  padding: 40px 8px;
  justify-content: center;
  .booking-label-search-item {
    padding: 10px 15px;
    margin-right: 15px;
    margin-bottom: 15px;
    font-size: 13px;
    cursor: pointer;
  }
  .booking-label-search-item-current {
    background: linear-gradient(90deg, #002d5d 38%, #da0032 100%);
    box-shadow: 0px 5px 15px 0px rgba(228, 99, 94, 0.13);
    color: #fff;
    &::before {
      content: "";
      display: none;
    }
  }
}
</style>